export default function USBA(props: any) {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="3.42969" y="14.5947" width="41.1429" height="20.5714" rx="2.74286" stroke="white" strokeWidth="2.25" />
            <rect x="8.57031" y="19.7383" width="30.8571" height="4.28571" rx="0.685714" fill="white" />
            <rect x="8.57031" y="28.3096" width="8.57143" height="1.71429" rx="0.171429" fill="white" />
            <rect x="30.8555" y="28.3096" width="8.57143" height="1.71429" rx="0.171429" fill="white" />
        </svg>
    );
}
